import { client } from './client';
import interceptors from './interceptors';
import qs from 'qs';

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getProvinces() {
    return client.get('/tunnel/api/public/general/province');
}

function getCity(code) {
    return client.get('/tunnel/api/public/general/city', {
        params: {
            'province_id': code
        }
    });
}

function getDistrict(code) {
    return client.get('/tunnel/api/public/general/subdistrict', {
        params: {
            'city_id': code
        }
    });
}

function getAddressList(param) {
    return client.get('/tunnel/api/member/address/data', {
        params: param
    });
}

function getAddressDetail(params) {
    return client.get('/tunnel/api/member/address/detail', {
        params: {
            id: params
        }
    });
}

function addAddress(params) {
    return client.post('/tunnel/api/member/address/add', qs.stringify(params), {
        header: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
    });
}

function updateAddress(params) {
    return client.post('/tunnel/api/member/address/update', qs.stringify(params), {
        header: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
    });
}

function utamaAddress(params) {
    return client.post('/tunnel/api/member/address/updateUtama', qs.stringify(params), {
        header: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
    });
}

function deleteAddress(params) {
    return client.post('/tunnel/api/member/address/delete', qs.stringify(params), {
        header: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
    });
}

export default {
    getProvinces,
    getCity,
    getDistrict,
    getAddressList,
    getAddressDetail,
    addAddress,
    updateAddress,
    utamaAddress,
    deleteAddress
};